import { createContext } from 'react';
import { ThgConfigModel } from './ThgConfigModel';
export const extendedConfigContext = createContext<ThgConfigModel>({});
